<template>
  <v-container :fluid="true" style="width: 100%" v-if="isActive">
    <v-alert type="info" class="rounded-lg">
      Напоминаем про необходимость всем делегатам иметь при себе паспорт.
    </v-alert>
    <v-card
      class="rounded-lg mb-4 mt-2 pa-3"
    >
      Список делегатов доступен по <a href="/docs/conf_25.06.2025.pdf">ссылке</a>.
    </v-card>
  </v-container>
  <v-container style="" v-else>
    <DisableServices ></DisableServices>
  </v-container>
</template>

<script>
// TODO: Закомментировать делегатов после выборов
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import TitledPageMixin from "@/mixins/TitledPageMixin"
import store from '@/store'
import { FEEDBACK_INSTANCE } from '@/helper/consts'
import DisableServices from '@/modules/templates/DisableServices.vue'

export default {
  name: "AppealPage",
  mixins: [FormErrorsMixin, TitledPageMixin],
  components: {
    DisableServices
  },
  data () {
    return {
      page_title: "Делегаты конференции",
      loading: false,
      success: false,
      errorSend: false,
      data: {
        file: [],
        text: '',
      },
    }
  },
  computed: {
    isActive () {
      return store.getters['urls/checkAlreadyLoaded'](FEEDBACK_INSTANCE)
    },
  },
  watch: {},
  methods: {},
  created () {
  }
}
</script>

<style scoped>

</style>
